function Somalia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2138)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#338AF3"/>
  <path d="M16 8.34766L17.7267 13.662H23.3145L18.7939 16.9463L20.5206 22.2607L16 18.9763L11.4794 22.2607L13.2061 16.9463L8.68542 13.662H14.2732L16 8.34766Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Somalia;
